module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/brave.784d106.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/brave.jpg
// module id = 5K7r
// module chunks = 0